import {appConfig} from '../config'

export function getPassportRetpath(windowLocation: Location['href']) {
  const location = new URL(windowLocation)
  const {from, to, zoneName} = appConfig.initialProps

  if (!from && !to && !zoneName) {
    return location.toString()
  }

  if (from || to) {
    location.searchParams.delete('from')
    location.searchParams.delete('to')
  }

  if (zoneName) {
    const segments = location.pathname.split('/')

    if (segments.includes(zoneName)) {
      location.pathname = segments.filter(segment => segment && segment !== zoneName).join('/')
    }
  }

  return location.toString()
}
